import React from 'react';
import { useStateValue } from "../StateProvider";
//import SongImage from "../FeedbackCarousel/SongBoxes/SongImage";

function RatingOfSongLine({ ratingLineToDecipher }) {
  const [{ userTier }] = useStateValue();

//!!!!SHOWALL RATINGS (PAID) VS ONLYSHOWLATEST !!!_S T A R T

  // Check if user is premium based on subscription config
  const isPayingUser = userTier === 'premium' ? 1 : 0; // 0=cover 3rd-5th of every 5, 1=all

//!!!!SHOWALL RATINGS (PAID) VS ONLYSHOWLATEST !!!_END


  // REVERSE
  function reverseArr(input) {
    var ret = [];
    for (var i = input.length - 1; i >= 0; i--) {
      ret.push(input[i]);
    }
    return ret;
  }

  // Both tiers now display ratings newest-first (reversed).
  let newDatesOfRatingsFetched = reverseArr(ratingLineToDecipher.ratingdates);
  let newRatingsOfSongFetched = reverseArr(ratingLineToDecipher.ratingscores);

  //Wieviele Ratings gibt es? - START

  // Render every rating; free users have some covered up (see below).
  const count = newRatingsOfSongFetched.length;

  // Free users: within every block of 5 ratings, the 3rd, 4th and 5th are
  // covered up. Premium users never have any rating covered.
  const isCovered = (i) => isPayingUser !== 1 && (i % 5) >= 2;

  //Wieviele Ratings gibt es? - END

  //Für jedes Element eine Aktion machen - START

        //alle rating Elemente
  const ratingElements = [];
  let hasCoveredRatings = false;

  for (let i = 0; i < count; i++) {


    // CREATE DATE
    //indexofrating
    const ratingDate = newDatesOfRatingsFetched[i];
    const ratingDateToString = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(ratingDate);

    //CREATE SONG NAME
    //indexofrating

    //CREATE RATING
    //indexofrating
    const RatingStrippedDown = newRatingsOfSongFetched[i].split('-*_1&7&1&')[1];

    // Covered up rating (free tier, 3rd-5th of every block of 5)
    if (isCovered(i)) {
      hasCoveredRatings = true;
      ratingElements.push(
        <div
          key={i}
          className="ratingLine ratingLineCovered"
          onClick={(e) => {
            e.stopPropagation();
            window.dispatchEvent(new Event('openSubscription'));
          }}
          style={{ position: 'relative', cursor: 'pointer' }}
        >
          <div style={{ filter: 'blur(5px)', userSelect: 'none', pointerEvents: 'none' }}>
            <strong>{ratingDateToString}</strong>
            :&nbsp;Your song just received 1 play and the&nbsp;
            <strong>rating:&nbsp;</strong>
            🔥 Added to my playlist!
            <br />
          </div>
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
              color: '#ffffff'
            }}
          >
            🔒 Upgrade to reveal this rating
          </div>
        </div>
      );
      continue;
    }

    //Ale in rating elements array schreiben
    ratingElements.push(
      <div key={i} className="ratingLine">
        <div>
          <strong>{ratingDateToString}</strong>

          :&nbsp;Your song&nbsp;
          {/* <strong> {songNameCreated} </strong> */}
          just received 1 play and the&nbsp;
          <strong>rating:&nbsp;</strong>
          {(RatingStrippedDown === "1") ? ("😉 Not for me") :
            (RatingStrippedDown === "2") ? ("🟢 Mediocore") :
              (RatingStrippedDown === "3") ? ("🎉 Great Song!") :
                (RatingStrippedDown === "4") ? ("🔥 Added to my playlist!") : ("leer")}
          <br />
        </div>
      </div>
    );
  }

  // Add upgrade message for free users if any ratings were covered up
  const hasHiddenRatings = hasCoveredRatings;

  return (
    <>
      {ratingElements}
      {hasHiddenRatings && (
        <div className="upgrade-message" style={{
          padding: '15px',
          marginTop: '20px',
          backgroundColor: '#333333',
          border: '1px solid #ffffff',
          borderRadius: '0',
          textAlign: 'center'
        }}>
          <p style={{ margin: '0 0 10px 0', fontWeight: 'bold', color: '#ffffff' }}>
            🔒 Some of your ratings are covered up
          </p>
          <p style={{ margin: '0 0 10px 0', color: '#ffffff' }}>
            Only premium users can see all ratings
          </p>
          <button
            className="subscribe-button"
            onClick={(e) => {
              e.stopPropagation();
              window.dispatchEvent(new Event('openSubscription'));
            }}
            style={{
              padding: '10px 20px',
              backgroundColor: '#90ee90',
              color: '#000000',
              border: 'none',
              borderRadius: '0',
              fontWeight: 'bold',
              cursor: 'pointer',
              touchAction: 'manipulation',
              WebkitTapHighlightColor: 'transparent',
              position: 'relative',
              zIndex: 1000
            }}
          >
            Upgrade to Premium
          </button>
        </div>
      )}
    </>
  );
}

export default RatingOfSongLine;
